import { Component, Input, OnInit } from '@angular/core';

import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { DateInputTypesEnum } from '../../../Forms/enums/date-input-types.enum';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import {
    dateQueryInput10MonthsOption,
    dateQueryInput11MonthsOption,
    dateQueryInput120DaysOption,
    dateQueryInput12MonthsOption,
    dateQueryInput1MonthOption,
    dateQueryInput2MonthsOption,
    dateQueryInput30DaysOption,
    dateQueryInput365DaysOption,
    dateQueryInput3DaysOption,
    dateQueryInput3MonthsOption,
    dateQueryInput4MonthsOption,
    dateQueryInput5MonthsOption,
    dateQueryInput60DaysOption,
    dateQueryInput6MonthsOption,
    dateQueryInput7DaysOption,
    dateQueryInput7MonthsOption,
    dateQueryInput8MonthsOption,
    dateQueryInput90DaysOption,
    dateQueryInput9MonthsOption,
    getDateQueryInputCustomOption
} from '../../../Forms/models/date-query-input-options.model';
import { DateQueryTypeEnum } from '../../../../api/mentions/enum/date-query-type.enum';
import { ReportDateRangeModel } from '../../models/report-date-range.model';
import { ReportSeriesModel } from '../../models/report-series.model';
import { TimePeriodEnum } from '../../../../api/shared/models/date-range-api.model';
import { DateQueryModel } from '../../../Forms/models/date-query.model';

@Component({
    selector: 'agpr-external-data-source-date-range-field',
    templateUrl: './external-data-source-date-range-field.component.html',
    styleUrls: ['./external-data-source-date-range-field.component.scss'],
    standalone: false
})
export class ExternalDataSourceDateRangeFieldComponent extends AbstractFormFieldComponent implements OnInit {
    readonly timePeriodEnum = TimePeriodEnum;
    readonly dateInputTypesEnum = DateInputTypesEnum;

    readonly customPresets: DropdownOptionModel[] = [
        getDateQueryInputCustomOption(),
    ];

    readonly dailyRelativePresets: DropdownOptionModel[] = [
        getDateQueryInputCustomOption(),
        dateQueryInput3DaysOption,
        dateQueryInput7DaysOption,
        dateQueryInput30DaysOption,
        dateQueryInput60DaysOption,
        dateQueryInput90DaysOption,
        dateQueryInput120DaysOption,
        dateQueryInput365DaysOption
    ];
    readonly monthlyRelativePresets: DropdownOptionModel[] = [
        getDateQueryInputCustomOption(),
        dateQueryInput1MonthOption,
        dateQueryInput2MonthsOption,
        dateQueryInput3MonthsOption,
        dateQueryInput4MonthsOption,
        dateQueryInput5MonthsOption,
        dateQueryInput6MonthsOption,
        dateQueryInput7MonthsOption,
        dateQueryInput8MonthsOption,
        dateQueryInput9MonthsOption,
        dateQueryInput10MonthsOption,
        dateQueryInput11MonthsOption,
        dateQueryInput12MonthsOption
    ];

    selectedDateInputType: DateInputTypesEnum;
    selectedTimePeriod: TimePeriodEnum;
    dateRangeOptions: DropdownOptionModel[];

    @Input() declare value: ReportSeriesModel[];

    dateRange: ReportDateRangeModel;

    ngOnInit(): void {
        this.dateRange = this.value[0]?.dateRange;

        if (this.dateRange?.type === DateQueryTypeEnum.ABSOLUTE) {
            this.dateRangeOptions = this.customPresets;
            this.selectedDateInputType = DateInputTypesEnum.custom;
            this.selectedTimePeriod = null;
        } else {
            this.selectedDateInputType = DateInputTypesEnum.useValue;
            this.selectedTimePeriod = this.dateRange.timePeriod ? this.dateRange.timePeriod : TimePeriodEnum.daily;
            this.dateRangeOptions = this.selectedTimePeriod === TimePeriodEnum.daily ? this.dailyRelativePresets : this.monthlyRelativePresets;
            // if date range dropdown options do not contain the initial date range, setting it to default
            if (!this.dateRangeOptions.find(option => this.dateRange.relativeStartOffsetH
                && (option.value.query as DateQueryModel).relativeStartOffsetH === this.dateRange.relativeStartOffsetH)) {
                this.setDefaultDateRange();
            }
        }
    }

    handleDateInputTypeChange(event?: any): void {
        if ( this.selectedDateInputType === DateInputTypesEnum.custom ) {
            this.selectedTimePeriod = null;
            this.dateRangeOptions = this.customPresets;
            this.dateRange = new ReportDateRangeModel();

        } else if (this.selectedDateInputType === DateInputTypesEnum.useValue) {
            if (!this.selectedTimePeriod) {
                this.selectedTimePeriod = TimePeriodEnum.daily;
                this.handleTimePeriodChange();
            }
        }

        this.handleChanges();
    }

    handleTimePeriodChange(event?: any): void {
        this.dateRangeOptions = this.selectedTimePeriod === TimePeriodEnum.daily ? this.dailyRelativePresets :  this.monthlyRelativePresets;
        this.setDefaultDateRange();
    }

    handleChanges(): void {
        this.value.forEach(series => {
            series.dateRange = new ReportDateRangeModel().setFromDateQuery(this.dateRange);
            series.dateRange.setTimePeriod(this.selectedTimePeriod);
        });

        this.changes.emit(this.value.slice());
    }

    setDefaultDateRange(): void {
        if (this.selectedTimePeriod === TimePeriodEnum.daily) {
            this.dateRange = new ReportDateRangeModel().setFromDateQuery(dateQueryInput30DaysOption.value.query);
        } else {
            this.dateRange = new ReportDateRangeModel().setFromDateQuery(dateQueryInput6MonthsOption.value.query);
        }

        this.dateRange.setTimePeriod(this.selectedTimePeriod);
        this.handleChanges();
    }

    handleDateRangeChange(event?: any): void {
        // if we set a custom date range, switch the radio button to 'custom'
        if (this.dateRange.type === DateQueryTypeEnum.ABSOLUTE) {
            this.selectedDateInputType = DateInputTypesEnum.custom;
        }

        this.handleChanges();
    }
}
